<template>
  <Component
    ref="header"
    :is="maxSmall ? DrawerHeader : DialogHeader"
    v-bind="
      maxSmall
        ? {
            title: $t('components.buttons.settings'),
            leadingAction: {
              as: DialogClose,
              label: $t('components.buttons.cancel'),
            },
          }
        : {
            title: $t('components.notifications.settings.title'),
            description: $t('components.notifications.settings.description'),
          }
    "
    class="bg-primary md:p-6 md:pb-5 md:border-b border-secondary"
  />
</template>

<script setup>
import { ref } from "vue";
import { DialogClose, DialogHeader } from "@/SharedComponents/Dialog";
import { DrawerHeader } from "@/SharedComponents/Drawer";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

const header = ref(null);

defineExpose({ close: () => header.value.close() });
</script>
